import { useMemo } from 'react';

import { useSelector } from '@bonanza-social/toolkit/state';

import {
  selectLoyaltyLevel,
  selectLoyaltyLevelDataState,
  selectLoyaltyLevelProgress,
  selectPoints,
} from '../state';

const useLoyalty = () => {
  const loyalty = useSelector(selectLoyaltyLevel);
  const points = useSelector(selectPoints);
  const progress = useSelector(selectLoyaltyLevelProgress);
  const loyaltyDataState = useSelector(selectLoyaltyLevelDataState);

  const returnObj = useMemo(
    () => ({
      loyalty,
      points,
      progress,
      loyaltyDataState,
    }),
    [loyalty, loyaltyDataState, points, progress],
  );

  return returnObj;
};

export default useLoyalty;
